import type { FleetPlates } from '@chukua/common';
import type { RigVehicles } from '../../reference-data/features/tyre-layouts/public/RigShowcase';

/**
 * The fleet's vehicles paired into rigs, a tractor with a trailer, in the order they came (already
 * random): the first for the company's own rig, the rest for the others. A fleet with more of one than
 * the other leaves the extra rigs' other vehicle unplated and in the brand colours.
 */
export function rigVehicles(fleet: FleetPlates): RigVehicles[] {
  const count = Math.max(fleet.trucks.length, fleet.trailers.length);
  return Array.from({ length: count }, (_, i) => ({ truck: fleet.trucks[i] ?? null, trailer: fleet.trailers[i] ?? null }));
}
